module.exports = __webpack_public_path__ + "img/accumulator.76a8945b.svg";